<template>
    <ion-card
        class="c-contract-icon-card"
        button
        :class="'-' + motive"
        @click="changePage()"
    >
        <ion-grid>
            <ion-row>
                <ion-col
                    size="10"
                    class="ion-padding"
                    v-if="!isKreditcheckliste"
                >
                    <div class="c-contract-icon-card__title">
                        {{ contract.Name }}
                    </div>
                    <ion-row class="c-contract-icon-card__balance">
                        <ion-col size="auto">
                            Nr. {{ contract.ContractIdFormatted }}
                        </ion-col>
                        <ion-col
                            class="ion-text-right"
                            v-if="
                                allgemeinConfig.ContractIdFormatted !=
                                'Polizzennummer'
                            "
                        >
                            <b>{{ contract.Balance | currency }}</b>
                        </ion-col>
                    </ion-row>
                </ion-col>
                <ion-col size="10" class="ion-padding" v-else>
                    <div class="c-contract-icon-card__title">
                        Kreditcheckliste
                    </div>
                    <span>{{ description }}</span> vom <b>{{ date }}</b>
                </ion-col>
                <ion-col
                    size="2"
                    class="ion-text-center c-contract-icon-card__icon"
                >
                    <!-- <ion-icon
            size="large"
            name="logo-model-s"
          ></ion-icon> -->

                    <ion-row
                        class="ion-justify-content-center"
                        style="height: 100%;"
                    >
                        <ion-col size="12" class="ion-align-self-center">
                            <div>
                                <span
                                    class="u-size-x-large icon-check"
                                    v-if="isKreditcheckliste"
                                ></span>
                                <span
                                    :class="'u-size-x-large icon-' + motive"
                                    v-else-if="motive !== 'allgemein'"
                                ></span>
                                <span
                                    class="u-size-x-large icon-pixelcloud"
                                    v-else
                                ></span>
                            </div>
                        </ion-col>

                        <!-- <ion-col size="12" align-self-center>
              <div>
                <span :class="'u-large icon-' + motive"></span>
              </div>
            </ion-col> -->
                    </ion-row>

                    <!-- <span class="icon-mobilitaet"></span> -->
                    <!-- <span class="icon-mobilitaet"></span> -->
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card>
</template>

<script>
export default {
    props: {
        contractId: {
            required: false,
            type: String,
            default: "",
        },
        isKreditcheckliste: {
            required: false,
            type: Boolean,
            default: false,
        },
        date: {
            required: false,
            type: String,
            default: "",
        },
        description: {
            required: false,
            type: String,
            default: "",
        },
        checklistKey: {
            required: false,
            type: String,
            default: "",
        },
    },
    // mounted() {
    //   this.$store.dispatch(
    //     "contractsDetails/getContractDetails",
    //     this.contractId
    //   );
    // },
    methods: {
        changePage() {
            if (this.isKreditcheckliste) {
                this.$router.push({
                    name: "kreditcheckliste",
                    params: {
                        motive: this.motive,
                        checklistKey: this.checklistKey,
                    },
                });
            } else {
                this.$router.push({
                    name: "vertrag",
                    params: {
                        motive: this.motive,
                        contractId: this.contractId,
                    },
                });
            }
        },
    },
    computed: {
        allgemeinConfig() {
            let result = {};
            if (
                this.contractId !== "" &&
                this.contractId in this.$store.state.contracts
            ) {
                // if (this.contractId in this.$store.state.contractsDetails.all) {
                // console.log(this.$store.state.contracts[this.contractId]);
                result = this.$store.state.contractsConfig[
                    this.$store.state.contracts[this.contractId].Sparte
                ].allgemein;
            }

            return result;
        },
        contract() {
            let result = {};
            if (
                this.contractId !== "" &&
                this.contractId in this.$store.state.contracts
            ) {
                result = this.$store.state.contracts[this.contractId];
            }
            return result;
        },
        motive() {
            // default motive
            let motive = "allgemein";
            if (this.isKreditcheckliste) {
                motive = "wohnen";
            } else if (
                this.contractId !== "" &&
                "Motives" in this.$store.state.contracts[this.contractId]
            ) {
                let motives = this.$store.state.contracts[this.contractId]
                    .Motives;
                let motiveKey = Object.keys(motives)[0];
                let motiveValue = motives[motiveKey];
                let motivesConfig = this.$store.state.motivesConfig;
                for (let motiveConfigKey in motivesConfig) {
                    if (motiveValue === motivesConfig[motiveConfigKey].motive) {
                        motive = motivesConfig[motiveConfigKey].path;
                        break;
                    }
                }
            }
            return motive;
        },
    },
};
</script>

<style lang="scss" scoped></style>
